<template>
  <div ref="content" class="col-12 col-md-11 col-lg-10 col-xl-8 p-2 pt-5 p-sm-5 mx-auto mt-3 mt-sm-5 cert-page-content">
    <div class="cert-article px-2 px-sm-4">
      <h3 class="mb-4">Password Attack</h3>
      <p>
        Password attacks involve exploiting flawed authorization vulnerabilities in systems in combination with
        automated password hijacking tools that accelerate password guessing and cracking. Attackers use a variety of
        techniques to access and disclose legitimate user credentials to disguise her identity and permissions.
        <br/>
        Hackers typically use a variety of techniques to obtain legitimate users' passwords and use them to authenticate
        themselves.
      </p>

      <h4 class="mt-5 mb-4">1. Phishing Attacks</h4>
      <p>
        The most common form of password attack, phishing attacks involve social engineering techniques in which
        hackers send malicious links to victims to impersonate trusted websites.
      </p>

      <h4 class="mt-5 mb-4">2. Brute-Force Password Attacks</h4>
      <p>
        This type of password attack uses a trial-and-error method to guess a user's credentials. Attackers use
        automated scripts to perform as many permutations as possible in order to correctly guess a user's password.
      </p>

      <h4 class="mt-5 mb-4">3. Dictionary Password Attacks</h4>
      <p>This attack method uses a predefined list of words that are most likely to be used as passwords on a given
        target network. A predefined list is created from website user behavior patterns and passwords obtained from
        previous data breaches. </p>

      <h4 class="mt-5 mb-4">4. Password Spraying Attack</h4>
      <p>In this attack, the hacker tries to authenticate with another account using the same password before switching
        to a different password. </p>

      <h4 class="mt-5 mb-4">5. Keylogging</h4>
      <p>When orchestrating a keylogging attack, hackers install monitoring tools on your computer to covertly record
        the keys you press. </p>

      <h4 class="mt-5 mb-4">How to Prevent Password Attacks?</h4>
      <p>Some best practices to prevent password attacks include:</p>
      <ul>
        <li>Enforce strong password policies</li>
        <li>Organization-wide password security training</li>
        <li>Enable Multifactor Authentication</li>
        <li>Use a password manager</li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  name: "GuideIncident"
}
</script>
